<template>
  <view class="content">
    <view class="card">
      <view class="tree-list">
        <TreeItem
          v-for="p in treeData"
          :key="p.id"
          :node="p"
          :level="0"
          :search-query="searchQuery"
          :expanded-map="expandedMap"
          :active-id="activeId"
          @toggle-expand="handleToggleExpand"
          @view-node="handleViewNode"
        />
      </view>
    </view>
    <BottomTabBar active="projects" />
  </view>
  </template>

<script>
import BottomTabBar from '@/components/BottomTabBar.vue'
import TreeItem from '@/components/TreeItem.vue'
export default {
  name: 'MyProjects',
  components: { BottomTabBar, TreeItem },
  data() {
    return {
      treeData: [],
      expandedMap: {},
      searchQuery: '',
      activeId: ''
    }
  },
  onLoad() {
    this.fetchProjects()
  },
  methods: {
    fetchProjects() {
      setTimeout(() => {
        this.treeData = [
          {
            id: 1,
            name: 'XX产业园建设项目',
            children: [
              { id: 11, name: '在库', children: [{ id: 111, name: '立项资料' }] },
              { id: 12, name: '前期', 
              children: [{ id: 121, name: '可研报告' }, { id: 122, name: '招标文件' }] },
              { id: 13, name: '实施', 
              children: [{ id: 131, name: '施工日志' }, { id: 132, name: '进度周报' }] },
              { id: 14, name: '竣工', children: [{ id: 141, name: '竣工资料' }] }
            ]
          },
          {
            id: 2,
            name: 'YY道路改造工程',
            children: [
              { id: 21, name: '在库', children: [{ id: 211, name: '立项资料' }] },
              { id: 22, name: '前期', children: [{ id: 221, name: '设计图纸' }] },
              { id: 23, name: '实施', children: [{ id: 231, name: '施工日志' }, { id: 232, name: '质量检测' }] },
              { id: 24, name: '竣工', children: [{ id: 241, name: '验收报告' }] }
            ]
          }
        ]
        this.treeData.forEach(p => { this.expandedMap[p.id] = true })
        if (this.treeData.length) {
          this.activeId = this.treeData[0].id
        }
      }, 300)
    },
    handleToggleExpand(id) {
      const next = { ...this.expandedMap }
      next[id] = !next[id]
      this.expandedMap = next
      this.activeId = id

    },
    handleViewNode(node) {
      this.activeId = node.id
    }
  }
}
</script>

<style scoped>
.content { width: 100%; min-height: 100vh; background-color: #f5f7fa; padding-bottom: 120rpx; }
.navbar { display: flex; align-items: center; justify-content: space-between; padding: 0 30rpx; height: 88rpx; background: linear-gradient(90deg, #1E88E5, #26A69A); color: #fff; }
.navbar-title { font-size: 36rpx; font-weight: 600; }
.card { background-color: #fff; margin: 20rpx; border-radius: 16rpx; padding: 24rpx; box-shadow: 0 2rpx 10rpx rgba(0,0,0,0.05); }
.tree-list { padding: 10rpx; }
</style>
